import httpApi from "./utils/httpClient";
console.log("document.location.hostname", document.location.hostname);
console.log("process.env.REACT_APP_DOMAIN", process.env.REACT_APP_DOMAIN);

export default {
  apiEndPoint: httpApi.defaults.baseURL,
};
